// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KssI","requiredAsterisk":"Info_requiredAsterisk__sgaLJ"};